var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth"},[_c('router-link',{staticClass:"add-link",attrs:{"to":"/login"}},[_vm._v("Sign in")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }